// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"collapsible__39UES"};